const VISITOR_COOKIE = 'visitor_token'
const VISIT_COOKIE = 'visit_token'
const VISITOR_TTL_DAYS = 730 // 2 years
const VISIT_TTL_MS = 4 * 60 * 60 * 1000 // 4 hours

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match?.[1] ? decodeURIComponent(match[1]) : null
}

function setCookie(name: string, value: string, maxAgeMs: number) {
  const maxAgeSec = Math.round(maxAgeMs / 1000)
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSec}; SameSite=Lax`
}

function getOrCreateToken(name: string, maxAgeMs: number): string {
  let token = getCookie(name)
  if (!token) {
    token = crypto.randomUUID()
  }
  // Refresh expiry on every access
  setCookie(name, token, maxAgeMs)
  return token
}

function getUtmParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search)
  const utm: Record<string, string> = {}
  for (const key of ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign']) {
    const val = params.get(key)
    if (val) utm[key] = val
  }
  return utm
}

async function post(path: string, body: Record<string, unknown>) {
  try {
    await fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    })
  } catch {
    // Silently ignore tracking failures
  }
}

export async function ensureVisit() {
  const visitorToken = getOrCreateToken(VISITOR_COOKIE, VISITOR_TTL_DAYS * 24 * 60 * 60 * 1000)
  const visitToken = getOrCreateToken(VISIT_COOKIE, VISIT_TTL_MS)

  await post('/tracking/visit', {
    visitor_token: visitorToken,
    visit_token: visitToken,
    referrer: document.referrer || null,
    landing_page: window.location.href,
    ...getUtmParams(),
  })
}

export function trackView() {
  const visitToken = getCookie(VISIT_COOKIE)
  if (!visitToken) return

  post('/tracking/events', {
    visit_token: visitToken,
    name: '$view',
    properties: {
      url: window.location.href,
      title: document.title,
    },
  })
}

export function track(name: string, properties: Record<string, unknown> = {}) {
  const visitToken = getCookie(VISIT_COOKIE)
  if (!visitToken) return

  post('/tracking/events', {
    visit_token: visitToken,
    name,
    properties,
  })
}
